module.exports = __webpack_public_path__ + "static/media/patchs.87f6cdd5.png";